import { render, staticRenderFns } from "./GroupGetStarted.vue?vue&type=template&id=60e2b044&"
import script from "./GroupGetStarted.vue?vue&type=script&lang=js&"
export * from "./GroupGetStarted.vue?vue&type=script&lang=js&"
import style0 from "./GroupGetStarted.vue?vue&type=style&index=0&id=60e2b044&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports